import { render, staticRenderFns } from "./textSlider.vue?vue&type=template&id=4bff29ab&"
import script from "./textSlider.vue?vue&type=script&lang=js&"
export * from "./textSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports